import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DateTimeHelper } from 'src/app/utils/helpers/date-time.helper';
import { TimeRestriction } from './models/time-restriction.model';

@Injectable({
  providedIn: 'root'
})
export class TimeRestrictionService {
  private timeRestrictions: TimeRestriction[] = [];
  private isShowOnlyMyExams$ = new BehaviorSubject(true);

  get isShowOnlyMyExamObservable(): Observable<boolean> {
    return this.isShowOnlyMyExams$.asObservable();
  }

  get isShowOnlyMyExam(): boolean {
    return this.isShowOnlyMyExams$.value;
  }

  set isShowOnlyMyExam(value: boolean) {
    this.isShowOnlyMyExams$.next(value);
  }

  constructor() { }

  addTimeRestriction(timeRes: TimeRestriction): void {
    this.timeRestrictions.push(timeRes);
  }

  deleteTimeRestriction(index: number): void {
    this.timeRestrictions.splice(index, 1);
  }

  editTimeRestriction(timeRes: TimeRestriction, index: number): void {
    this.timeRestrictions.splice(index, 1, timeRes);
  }

  getTimeRestrictions(): TimeRestriction[] {
    return this.timeRestrictions;
  }

  examInPast(): boolean {
    const now = new Date();
    const day = DateTimeHelper.getLocalDate(now);
    const today = new Date(day);
    for (const time of this.timeRestrictions) {
      const timeSlot = new Date(time.day);

      if (timeSlot.getTime() < today.getTime()) { // timeslot is before today
        return true;

      } else if (timeSlot.getTime() === today.getTime()) { // same day
        const splitTime: string[] = time.startUntilTime.split(':');
        const hours = +splitTime[0];
        const minutes = +splitTime[1];

        if (hours < now.getHours()) { // compare hours
          return true;
        } else if (hours === now.getHours() && minutes < now.getMinutes()) { // if hours are same, compare minutes
          return true;
        }
      }
    }

    return false;
  }

  reset(): void {
    this.timeRestrictions = [];
    this.isShowOnlyMyExams$.next(true);
  }
}
